'use client';

import { cn } from '~/lib/utils';
import { type THeroIcon } from '~/@types/interface';

export type DrawerTabItem<T extends string> = {
  key: T;
  title: React.ReactNode;
  icon?: THeroIcon;
};

type DrawerTabsProps<T extends string> = {
  tab: T;
  onTabChange: (tab: T) => void;
  tabs: DrawerTabItem<T>[];
  className?: string;
};

export default function DrawerTabs<T extends string>({
  tab,
  onTabChange,
  tabs,
  className,
}: DrawerTabsProps<T>) {
  return (
    <nav
      className={cn(
        'border-border/80 flex shrink-0 items-center gap-4 overflow-x-auto border-b px-4',
        className,
      )}
      aria-label="Drawer sections"
    >
      {tabs.map((item) => {
        const Icon = item.icon;
        const isActive = tab === item.key;

        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onTabChange(item.key)}
            className={cn(
              'inline-flex items-center gap-1.5 border-b-2 border-transparent py-2.5 text-sm font-medium whitespace-nowrap transition-colors',
              isActive
                ? 'border-foreground text-foreground'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {Icon ? <Icon className="size-4" strokeWidth={2} /> : null}
            {item.title}
          </button>
        );
      })}
    </nav>
  );
}
